import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// CRA automatically loads the right .env file:
//   npm start  → .env.development (cuitt-a4d22)
//   npm build  → .env.production  (qwytt-prod)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const IS_DEBUG_PROJECT = firebaseConfig.projectId === 'cuitt-a4d22';

console.log(`[Firebase] ${IS_DEBUG_PROJECT ? 'DEV' : 'PROD'} → ${firebaseConfig.projectId}`);

export const app = initializeApp(firebaseConfig);

let analytics = null;
if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
  analytics = getAnalytics(app);
}
export { analytics };

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
